const bottomBar = {
  editMode: "Режим редактирования",
  done: "Готово",
  pickSlot: "Выбрать элемент",
  clearSlot: "Очистить слот",
  pages: "Страницы",
  widgets: "Виджеты",
  longPressToEdit: "Длительное нажатие для редактирования",
  sidebar: "Меню",
  widgetPanel: "Виджеты",
  emptySlot: "Пусто",
  editBottomBar: "Редактировать нижнюю панель",
  menu: "Меню",
  more: "Ещё",
  navigation: "Навигация",
  openMenu: "Открыть меню",
  closeMenu: "Закрыть меню",
} as const;
export default bottomBar;
